export default {
	name: "indexView", // 风采展示
	data() {
		return {
			navList: [],
			honorList: [],
			imageList: [],
		};
	},
	watch: {},
	created() {
		const menuList = JSON.parse(localStorage.getItem("menuList"));
		if (menuList && menuList.data) {
			this.navList = menuList.data;
			console.log("this.navList", this.navList);
		}
	},
	async mounted() {
		await this.getHonor();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async getHonor() {
			const listRes = await this.$zkHttp.index$getHonor();
			console.log("listRes", listRes);
			this.honorList = listRes;
			this.imageList = listRes.map(e => e.image);
		},
	},
};